import request from 'Request'

const VirtualOfficesService = {
  async get({ virtualOfficeId }) {
    return request.get('/virtual-offices/get', { params: { virtualOfficeId } })
  },

  async list({ userId } = {}) {
    return request.post('/virtual-offices/list', { userId })
  },

  async create({ title, officeIds, appCodes, deleted }) {
    return request.put('/virtual-offices/create', { title, officeIds, appCodes, deleted })
  },

  async update({ virtualOfficeId, title, archived }) {
    return request.patch('/virtual-offices/update', { virtualOfficeId, title, archived })
  },

  async addUsers({ virtualOfficeId, users }) {
    return request.put('/virtual-offices/add-child', {
      virtualOfficeId,
      users
    })
  },

  async removeUsers({ virtualOfficeId, users }) {
    return request.delete('/virtual-offices/remove-child', {
      data: {
        virtualOfficeId,
        users
      }
    })
  },

  async addOfficeIds({ virtualOfficeId, officeIds }) {
    return request.put('/virtual-offices/add-child', {
      virtualOfficeId,
      officeIds
    })
  },

  async removeOfficeIds({ virtualOfficeId, officeIds }) {
    return request.delete('/virtual-offices/remove-child', {
      data: {
        virtualOfficeId,
        officeIds
      }
    })
  },

  async addAppCodes({ virtualOfficeId, appCodes }) {
    return request.put('/virtual-offices/add-child', {
      virtualOfficeId,
      appCodes
    })
  },

  async removeAppCodes({ virtualOfficeId, appCodes }) {
    return request.delete('/virtual-offices/remove-child', {
      data: {
        virtualOfficeId,
        appCodes
      }
    })
  }
}

export default VirtualOfficesService
